import { RadioGroup } from '@mui/material';
import React, { FC } from 'react';
import { SurveyTemporalFilterType } from '../../Surveys/surveyInterface';
import FormInfoTooltip from '../FormInfoTooltip';
import { FormGroup } from '../formInterfaces';
import { FormLabelStyled, StyledFormControl, FormControlLabelStyled, RadioButtonStyled, RequiredAsteriskStyled } from '../styled';

const RadioSelectForm: FC<Partial<FormGroup>> = ({ label, value, onChange, choices, isOptional, information }) => {
    const handleChange = (choice: {id: boolean | string | SurveyTemporalFilterType, label: string}) => {
        onChange?.(choice);
    };

    return (
        <StyledFormControl style={{ marginTop: '15px' }}>
            <FormLabelStyled>
                {label}{information && <FormInfoTooltip information={information} />}{isOptional === false && <RequiredAsteriskStyled>*</RequiredAsteriskStyled>}
            </FormLabelStyled>
            <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                name="radio-buttons-group"
                sx={{ display: 'flex', flexDirection: 'row', gap: '24px' }}
                value={value}
            >
                {choices?.map((choice) => (
                    <FormControlLabelStyled
                        key={choice.id}
                        control={<RadioButtonStyled />}
                        ischecked={value === choice.id ? 1 : 0}
                        label={choice.label}
                        onClick={() => handleChange(choice)}
                        value={choice.id}
                    />
                ))}
            </RadioGroup>
        </StyledFormControl>
    );
};

export default RadioSelectForm;
